<template lang="pug">
v-card.elevation-0
  v-slide-group(v-model='model' active-class='success' show-arrows='')
    v-slide-item(v-for='(i, index) in involucrados' :key='index' v-slot='{ active, toggle }')
      v-card.mr-2(width="85", @click="() => {}")
        v-img.white--text.align-end(:height="isMovil ? 100  : 110"  :src="i.foto ? i.foto : '/static/nobody.jpg'"  gradient="to bottom, rgba(0,0,0,.1),#161f2b85")
          v-tooltip(bottom='')
            template(v-slot:activator='{ on, attrs }')
              v-icon.position(v-if="i.isCreador" v-bind='attrs' v-on='on') info
            small Creador del ticket

          .d-flex.fd-column.pa-3
            span(:class="isMovil ? 'font-size-11' : 'font-size-12'") {{i.nombre}}
            span.font-size-11.text-muted(v-if="!isMovil") {{i.cargo}}
</template>
<script>
import { apiGet, notify } from '../util/general'
export default {
  props : {
    numero : {
      type   : Number,
      default: 0
    }
  },
  data () {
    return {
      involucrados: [],
      isLoading   : false,
      model       : null
    }
  },
  created () {
    var vm = this
    vm.fetch()
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods : {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/ticket/' + vm.numero + '/actividades/involucrados', obj, function (data) {
        vm.involucrados = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.position
  position absolute !important
  top: 4px;
  right: 4px;
</style>



// WEBPACK FOOTER //
// c_usuarios_involucrados_ticket.vue?78673b80